import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    customerId: null,
    customerName: '',
    customerSearch: '',
    ledgerType: 'with details',
    fromDate: null,
    toDate: null,
    rawFrom: null,
    rawTo: null,
  },
  list: [],
  loading: false,
  openingBalance: 0,
  closingBalance: 0,
  selectedCustomer: null,
  searchResults: [],
  loadingSearch: false,

  // ✅ linked supplier state
  linkedParty: null,          // { linked_acc_id, linked_acc_code, supplier_opening, supplier_closing }
  supplierLedgerList: [],     // supplier ledger rows
  supplierOpeningBalance: 0,
  supplierClosingBalance: 0,
};

const customerLedgerSlice = createSlice({
  name: 'customerLedger',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setLedgerData: (state, action) => {
      state.list            = action.payload.ledger           || [];
      state.openingBalance  = action.payload.opening_balance  || 0;
      state.closingBalance  = action.payload.closing_balance  || 0;
      state.selectedCustomer = action.payload.customer        || null;

      // ✅ linked supplier data
      if (action.payload.linked_party) {
        state.linkedParty            = action.payload.linked_party;
        state.supplierLedgerList     = action.payload.linked_party.ledger           || [];
        state.supplierOpeningBalance = action.payload.linked_party.opening_balance  || 0;
        state.supplierClosingBalance = action.payload.linked_party.closing_balance  || 0;
      } else {
        state.linkedParty            = null;
        state.supplierLedgerList     = [];
        state.supplierOpeningBalance = 0;
        state.supplierClosingBalance = 0;
      }
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingSearch: (state, action) => {
      state.loadingSearch = action.payload;
    },
    resetState: () => initialState,
  },
});

export const {
  setFilters, setLedgerData, setSearchResults,
  setLoading, setLoadingSearch, resetState
} = customerLedgerSlice.actions;
export default customerLedgerSlice.reducer;